@let size = $size();

<button
  type="button"
  tuiIconButton
  (click)="copyToClipboard()"
  [size]="size"
  class="rounded-lg!"
  [appearance]="$appearance()"
  iconStart="@tui.copy"
></button>
